import type { Status, StatusCounts } from '../types';
import { STATUS_LABELS } from '../types';

const CARDS: Array<{ key: Status | 'total'; sub: string }> = [
  { key: 'total', sub: 'Across all sources' },
  { key: 'healthy', sub: 'Backed up recently' },
  { key: 'warning', sub: 'Needs attention soon' },
  { key: 'failed', sub: 'Immediate action required' },
  { key: 'paused', sub: 'Paused or archived on purpose' },
  { key: 'unknown', sub: 'No data reported' },
];

interface Props {
  counts: StatusCounts;
  active: Status | 'all';
  onFilter: (s: Status | 'all') => void;
}

export function SummaryCards({ counts, active, onFilter }: Props) {
  return (
    <div className="summary-grid">
      {CARDS.map(({ key, sub }) => {
        const isTotal = key === 'total';
        const value = isTotal ? counts.total : counts[key];
        const filterValue: Status | 'all' = isTotal ? 'all' : key;
        return (
          <button
            key={key}
            className={
              `card card-${key}` + (active === filterValue ? ' active' : '')
            }
            onClick={() => onFilter(filterValue)}
          >
            <div className="card-label">{isTotal ? 'Total' : STATUS_LABELS[key]}</div>
            <div className="card-value">{value}</div>
            <div className="card-sub">{sub}</div>
          </button>
        );
      })}
    </div>
  );
}
